import React, { memo, forwardRef } from "react";
const SvgReplyArrow1 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M6 12h15a6 6 0 016 6v0a6 6 0 01-6 6H7.91"
      />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 7l-5 5 5 5"
      />
    </svg>
  );
});
SvgReplyArrow1.displayName = "SvgReplyArrow1";
const MemoForwardRef = memo(SvgReplyArrow1);
export default MemoForwardRef;
